import React, { Component } from "react";
import notFound from '../resources/images/notFound.png';
import './style.scss';

export default class NotFound extends Component {
  render() {
    return (
      <div className="row w-100">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-6 p-t-3">
              <div className="container mb-4">
                <h2 className="text-purple m-t-3 p-t-3">Looks like we can’t find that page.</h2>
              </div>
              <div className="container mb-4">
                <h5 className="text-green" data-testid="home-click" onClick={() => this.props.history.replace('/')}>Return to Homepage > </h5>
              </div>
            </div>
            <div className="col-md-6 p-t-6">
              <img src={notFound} alt="Not found"></img>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
